import { render, staticRenderFns } from "./patient_card_createtext.vue?vue&type=template&id=3fed9e7e&scoped=true"
import script from "./patient_card_createtext.vue?vue&type=script&lang=js"
export * from "./patient_card_createtext.vue?vue&type=script&lang=js"
import style0 from "./patient_card_createtext.vue?vue&type=style&index=0&id=3fed9e7e&prod&lang=scss&scoped=true"
import style1 from "./patient_card_createtext.vue?vue&type=style&index=1&id=3fed9e7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fed9e7e",
  null
  
)

export default component.exports